import React, { Component } from 'react';
import './view-chapter-all-video.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CwContentViewer from '../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../common/canvas/canvas'
import GeometryTranspiler from '../../common/geometry/geometry-parser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEllipsisV, faExpandArrowsAlt, faArrowLeft, faArrowRight, faDotCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalBody } from 'reactstrap';
import HomeworkApi from '../../../apis/homework';
import Dropdown from '../../common/dropdown-v2/dropdown';
import CommonApi from '../../../apis/common';

class ChapterAllVideos extends Component {

    state = {
        completedStudents: [],
        notCompletedStudents: [],
        questions: [],
        usersInfo: [],
        showImage: [],
        conceptsInfo: this.props.conceptsInfo.length ? this.props.conceptsInfo : [],
        totalVideoCount: 0,
        selectedConceptInfo: []
    }





    constructor(props) {
        super(props)

    }


    componentDidMount() {
        // const element = document.getElementById("page-scroll-to-top-1");
        // element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        // console.log(this.state.conceptsInfo)

        let totalVideoCount = 0

        this.state.conceptsInfo.forEach(concept => {

            if (concept.conceptWiseVideoLearningContent.length) {
                totalVideoCount += concept.conceptWiseVideoLearningContent.length
            }

        })

        this.setState({ totalVideoCount: totalVideoCount })

    }


    getSearchedVideoLearningContent() {

        let payload = {
            selectedClass: this.props.selectedClass,
            board: this.props.selectedBoard,
            masterDataId: this.props.masterDataId,
            chapterKey: this.props.chapterKey,
            searchText: this.state.search,
            conceptKey: this.state.selectedConcept
        }

        CommonApi.getSearchedVideoLearningContent(payload).then(response => {
            console.log(response)

            this.setState({ conceptsInfo: response.chapter })

        })
            .catch(err => {
                console.log(err)
            })


    }




    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    goToChapterListScreen = () => {
        this.props.goToChapterListScreen && this.props.goToChapterListScreen()
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb '>
                <span className='bread-crumb-title' onClick={this.goToChapterListScreen}>{`${this.props.selectedClass || ""} >`}</span>
                <span className='pl-2 bread-crumb-title' onClick={() => this.toggleBack()} >{`${this.props.chapterTitle || ""}`}</span>
                {/* <span className='pl-2'>{this.props.selectedElo?.conceptTitle} {`>`} </span>
                <span className='active pl-2'>{this.props.selectedElo?.title}</span> */}
            </div>
        )
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

   

    renderContentType = (contentType, content) => {

        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div className='row'>
                            {content.content.options.map((item, index) =>

                                <div className='col col-lg-6 col-md-6 col-sm-12'>
                                    <div className={`mb-4 ml-2 row sequence-option ${item.isCorrect ? 'correct-answer-light-border' : ''} `} >
                                        <div className='col-1 my-auto col-min-width'>
                                            {item.isCorrect && <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} onClick={() => this.onClickBack()} />}
                                        </div>
                                        <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
                                            <CwContentViewer content={item.content} />
                                            :
                                            <div className=''>
                                                <img className='image-option-container' src={item.content} alt="" />
                                            </div>
                                        }
                                        </div>

                                    </div>
                                </div>

                            )}

                        </div>
                    </div >

                )

            case 2:
                return (
                    <div className="row">
                        {content.content.options.map((item, index) =>
                            <div className="col col-lg-6 col-md-6 col-sm-11">

                                <div className='mb-4 ml-2 row sequence-option'>
                                    <div className='col-1 my-auto'>
                                        <div className='check-box'></div>
                                    </div>
                                    <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>
                                </div>

                            </div>
                        )}

                    </div>

                )

            case 4:
                return (

                    <div className='mb-4'>
                        <div className='row'>
                            {content.content.options.map((item, index) =>
                                <div className={`col-2 matching-option my-auto `} style={{ borderColor: 'red' }}>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div className='mb-4'>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-4 ml-2 row sequence-option'>
                                    <div className='col-2 my-auto'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div className='mb-4'>
                        <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-4'> {item.contentTypeName == 'TEXT' ?
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div>
                        <div className='row mt-4'>
                            {content.content.options.map((item, index) =>
                                <div className='ml-2 group-option'>
                                    <div className='group-header px-3'>
                                        <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                )

            case 10:
                if (content?.content?.canvas?.render?.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return ("")
        }

    }
    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    showSubmissions = (item, index) => {
        console.log(item)
        this.setState({ showSubmissions: true, selectedQuestion: item, selectedIndex: index })
    }

    toggleBack = () => {

        this.props.back && this.props.back()
    }

    getStatusText(value) {
        if (value == "CORRECT") return "Correct"
        else if (value == "IN_CORRECT") return "Incorrect"
        return "Not Attempted"
    }

    getStatusColor(value) {
        if (value == "CORRECT") return "text-success"
        else if (value == "IN_CORRECT") return "text-danger"
        return "text-warning"
    }

    onClickStatus(item, index, status) {
        console.log(item, index, status)

        let stats = item.stats

        let students = []

        if (status == "CORRECT") {
            students = stats?.correctUsers || []
        } else if (status == "IN_CORRECT") {
            students = stats?.inCorrectUsers || []
        } else if (status == "NOT_ATTEMPTED") {
            students = stats?.notAttemptedUsers || []
        }

        this.setState({ selectedQuestion: item, students, showStudentIndex: index, status })

        console.log(this.state.students)

    }

    onSelectDropDown = (option, key) => {
        console.log(option)

        if (option) {
            this.setState({ [key]: option?.value }, () => {

                let originalConcepts = this.props.conceptsInfo.length ? this.props.conceptsInfo : []

                let selectedConceptInfo = originalConcepts.filter(concept => concept.conceptKey === option?.value)

                this.setState({ conceptsInfo: selectedConceptInfo, selectedConceptInfo })
            })
        } else {
            this.setState({
                selectedConcept: '',
                search: '',
                selectedConceptInfo: [],
                conceptsInfo: this.props.conceptsInfo
            })
        }
    }

    onChangeHandler(event, key) {
        let value = event.target.value
        console.log(value)
        this.setState({ [key]: value })
    }

    onClickGo() {

        this.getSearchedVideoLearningContent()
    }


    onClickClear() {
        this.setState({
            selectedConcept: '',
            search: '',
            selectedConceptInfo: [],
            conceptsInfo: this.props.conceptsInfo
        }, () => {
            this.refreshPage()
        })



    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }


    closeStudents() {
        this.setState({ selectedItem: null, showStudentIndex: -1, reload: true }, () => {
            this.setState({ reload: false })
        })
    }


    showImageFullScreen = (images, index) => {

        const { showImage } = this.state
        showImage[index] = 0



        this.setState({
            currentIndex: index,
            selectedImages: images,
            showImageFullScreen: true,
            showImage
        })
    }

    hideImageFullScreen = _ => {
        this.setState({
            currentIndex: 0,
            selectedImages: [],
            showImageFullScreen: false
        })
    }

    changeImageIndex = (qIndex, iIndex) => {
        const { showImage } = this.state
        showImage[qIndex] = iIndex
        this.setState({
            showImage
        })
    }

    goToPrevImage = (qIndex) => {
        const { showImage } = this.state
        if (!showImage[qIndex] || showImage[qIndex] === 0) return
        showImage[qIndex] = showImage[qIndex] - 1
        this.setState({
            showImage
        })
    }

    goToNextImage = (qIndex, length) => {
        const { showImage } = this.state
        if (showImage[qIndex] === length - 1) return
        showImage[qIndex] = !showImage[qIndex] ? 1 : showImage[qIndex] + 1
        this.setState({
            showImage
        })
    }

    showVideoDetail(conceptIndex, index) {

        if (this.state.selectedVideoIndex === index && this.state.selectedConceptIndex === conceptIndex && this.state.showVideoDetail) {
            this.setState({ showVideoDetail: false, selectedVideoIndex: index, selectedConceptIndex: conceptIndex })
        } else {
            this.setState({ showVideoDetail: true, selectedVideoIndex: index, selectedConceptIndex: conceptIndex })
        }

        if (this.state.showIntroVideoDetail) {
            this.setState({ showIntroVideoDetail: false })
        }

    }

    showIntroVideoDetail(serialNumber) {
        this.setState({ showIntroVideoDetail: !this.state.showIntroVideoDetail, serialNumber: serialNumber })
    }

    videoEnded(chapterKey, chapterTitle, content, subType, type) {
        this.props.videoEnded && this.props.videoEnded(chapterKey, chapterTitle, content, subType, type)
    } 



    renderFullScreenImage() {
        const {
            selectedImages,
            currentIndex,
            showImage
        } = this.state
        const index = currentIndex;
        return (
            <Modal className="cw-custom-modal image-full-screen" isOpen={true} toggle={this.hideImageFullScreen} size={"xl"}>
                <ModalBody >
                    <div className="row px-2">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideImageFullScreen} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="px-5">
                        <div className='answer-image-container' >
                            {selectedImages?.length > 0 && selectedImages.map((image, imageIndex) => (
                                <>
                                    {((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) && <div className='answer-image text-center' key={imageIndex}>
                                        <img className='answer-image' src={image.url} />
                                    </div>
                                    }

                                </>
                            ))}
                            {selectedImages?.length > 0 &&
                                <div className='slider-pagination-buttons'>
                                    <div className='prev cursor-pointer' onClick={_ => {
                                        this.goToPrevImage(index)
                                    }}>
                                        <FontAwesomeIcon color='#FFFFFF' icon={faArrowLeft} />
                                    </div>
                                    {selectedImages.map((image, imageIndex) => (
                                        <div className='slider-page cursor-pointer' key={imageIndex} onClick={_ => {
                                            this.changeImageIndex(index, imageIndex)
                                        }}>
                                            <div className={`dot-circle ${((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) ? "active" : ""}`}>

                                            </div>
                                        </div>
                                    ))}
                                    <div className='next cursor-pointer' onClick={_ => {
                                        this.goToNextImage(index, selectedImages.length)
                                    }}><FontAwesomeIcon color='#FFFFFF' icon={faArrowRight} /></div>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {
                    this.state.students?.length ? this.state.students.map((item, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {item.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Student Attempted Homework</div>
                }
            </div>
        )
    }

    renderSolvedExamples() {

        let serialNumber = 0

        return (
            <div>
                {
                    this.props.chapterIntroductionVideo.length && !this.state.selectedConceptInfo.length ? this.props.chapterIntroductionVideo.map(introVideoContent => (
                        <div className='mb-4 video-learning-content-wrapper-header p-4 position-relative'>
                            <img className='blue-dimond-icon' src={getImageSource(ImageConstants.BLUE_DIMOND_ICON)} />
                            <div className='video-learning-content justify-content-start align-items-center position-relative flex-column'>

                                <div className="col-4">
                                    <div className='row align-items-center video-learning-content-title'>
                                        <div className='col-2 mr-1 d-flex justify-content-center align-items-center sr-no-bg '>
                                            <div className=' sr-no-bg-color'>{`${serialNumber += 1}`}</div>
                                        </div>
                                        <div className='col align-self-center sr-no'>{introVideoContent.displayTitle} </div>
                                    </div>

                                </div>
                                <div className="col-4"><CwContentViewer from={'video_only'} 
                                content={introVideoContent.content.description}
                                videoEnded={() => this.videoEnded(this.props.chapterKey, this.props.chapterTitle, introVideoContent, "CHAPTER_INTRODUCTION_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")}
                                 /></div>
                                <div className="col d-flex mt-2 button-wrapper">
                                    <div className="read-more-wrapper">
                                        <span className="read-more cursor-pointer" onClick={() => this.showIntroVideoDetail(serialNumber += 1)}>{`${this.state.showIntroVideoDetail == true ? "Hide More" : "View More"}`}</span>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.showIntroVideoDetail == true ?
                                    // <div className='video-detail'>
                                    //     {<CwContentViewer from={'video_content'} content={introVideoContent.content.description} />}
                                    // </div>
                                    <div className="p-3 position-relative">
                                        <img className="video-detail-header-image" src={getImageSource(ImageConstants.VIDEO_DETAIL_HEADER_IMAGE)} />
                                        <div className="video-detail-wrapper">
                                            <div className="elo-title p-4">
                                                {`Chapter Introduction Video`}
                                            </div>
                                            <div className="video-detail-divider"></div>
                                            <div className="pl-4 pr-4">
                                                <div className="d-flex video-learning-content-wrapper mt-4 mb-4 pb-2">
                                                    <div className='video-learning-content row '>
                                                        <div className="col content-alignment mt-2">
                                                            <div className='d-flex video-learning-content-title'>
                                                                {/* <div className='mr-1 sr-no '><span className='mt-3 sr-no-bg-color'>{`${this.state.serialNumber}.`}</span></div> */}
                                                                <div className='align-self-center sr-no'>{introVideoContent.displayTitle} </div>
                                                            </div>
                                                            <div className="video-content-wrapper">
                                                                {<CwContentViewer from={'video_content'} content={introVideoContent.content.description} />}
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    :
                                    <></>
                            }

                            {/* <div className='divider mt-1'></div> */}
                        </div>
                    ))

                        : <></>


                }
                {this.state.conceptsInfo.map((concept, conceptIndex) => (
                    <>

                        {concept?.conceptWiseVideoLearningContent?.length ? concept?.conceptWiseVideoLearningContent?.map((videoContent, index) => (
                            <div className='mb-4 video-learning-content-wrapper-header p-4 position-relative'>
                                <img className='blue-dimond-icon' src={getImageSource(ImageConstants.BLUE_DIMOND_ICON)} />

                                <div className='video-learning-content justify-content-start align-items-center flex-column position-relative'>

                                    <div className="col-4 ">
                                        <div className='row align-items-center  video-learning-content-title '>
                                            <div className='col-2 mr-2 d-flex justify-content-center align-items-center sr-no-bg '>
                                                <div className=' sr-no-bg-color'>{`${serialNumber += 1}`}</div>
                                            </div>
                                            <div className='col align-self-center sr-no'>{videoContent.displayTitle} </div>
                                        </div>

                                    </div>
                                    <div className="col-4 text-right"><CwContentViewer from={'video_only'} content={videoContent.content.description}
                                    videoEnded={() => this.videoEnded(this.props.chapterKey, videoContent.displayTitle, videoContent, "ELO_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")} /></div>
                                    <div className="col d-flex mt-2 button-wrapper">
                                        <div className="read-more-wrapper">
                                            <span className="read-more cursor-pointer" onClick={() => this.showVideoDetail(conceptIndex, index)}>{`${this.state.selectedConceptIndex === conceptIndex && this.state.selectedVideoIndex === index && this.state.showVideoDetail == true ? "Hide More" : "View More"}`}</span>
                                        </div>
                                    </div>
                                </div>

                                {
                                    this.state.selectedConceptIndex === conceptIndex && this.state.selectedVideoIndex === index && this.state.showVideoDetail == true ?
                                        // <>
                                        //     {<CwContentViewer from={'video_content'} content={videoContent.content.description} />}
                                        // </>
                                        <>
                                            <div className="p-3 position-relative">
                                                <img className="video-detail-header-image" src={getImageSource(ImageConstants.VIDEO_DETAIL_HEADER_IMAGE)} />
                                                <div className="video-detail-wrapper">
                                                    <div className="elo-title p-4">
                                                        {`${concept.title}`}
                                                    </div>
                                                    <div className="video-detail-divider"></div>
                                                    <div className="pl-4 pr-4">
                                                        <div className="d-flex video-learning-content-wrapper mt-4 mb-4 pb-2">
                                                            <div className='video-learning-content row '>
                                                                <div className="col content-alignment mt-2">
                                                                    <div className='d-flex video-learning-content-title'>
                                                                        {/* <div className='mr-1 sr-no '><span className='mt-3 sr-no-bg-color'>{`${this.state.serialNumber}.`}</span></div> */}
                                                                        <div className='align-self-center sr-no'>{videoContent.displayTitle} </div>
                                                                    </div>
                                                                    <div className="video-content-wrapper">
                                                                        {<CwContentViewer from={'video_content'} content={videoContent.content.description} />}
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </>
                                        : <></>
                                }

                                {/* <div className='divider mt-1'></div> */}
                            </div >
                        )) : this.state.selectedConceptInfo.length ?
                            <div>
                                <div className='d-flex justify-content-center pb-2'>No Video Content Found for {`${concept.title}`}</div>
                                {/* <div className='divider'></div> */}
                            </div>
                            : ''

                        }
                    </>
                ))
                }
            </div>
        )

    }

    render() {


        return (
            <div id='page-scroll-to-top-1' className='chapter-all-videos' >

                <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div>

                {!this.state.reload ?
                    <div className='p-3'>
                        <div className='row align-items-center heading-wrapper mt-2 p-2'>
                            <img className='all-video-eclipse' src={getImageSource(ImageConstants.ALL_VIDEO_ECLIPSE)} />
                            <img className='all-video-polygon' src={getImageSource(ImageConstants.ALL_VIDEO_POLYGON)} />
                            <div className='col-5 d-flex align-items-center'>
                                <div>
                                    <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.PLAY_ICON_ORANGE)} />
                                </div>
                                <div>
                                    <div className="header-text">{`All Videos `}<span className='videos-count'>{`(${this.state.totalVideoCount})`}</span> </div>
                                    <div className=''>{this.renderBreadcrumb()}</div>
                                </div>

                            </div>
                            <div className='col-2 ml-5  p-1'>
                                {/* <div className="filter-input-label">
                                    Concepts
                                </div> */}
                                <div>
                                    <Dropdown
                                        placeholder='Select a Concept'
                                        options={this.props.conceptsDropdownItems}
                                        onSelect={(option) => this.onSelectDropDown(option, "selectedConcept")}
                                        text={"title"}
                                        value={this.state.selectedConcept}
                                    />
                                </div>
                            </div>
                            <div className="col-2 p-1 ml-2">
                                {/* <div className="filter-input-label">
                                    Search
                                </div> */}
                                <div>
                                    <input
                                        className={`cw-input`}
                                        value={this.state.search}
                                        onChange={(event) => this.onChangeHandler(event, "search")}
                                        placeholder='Enter a Keyword' />
                                </div>

                            </div>

                            <div className="col ml-2 filter-buttons">
                                <div className="filter-button  d-inline-block" onClick={() => this.onClickGo()}>
                                    <button className={`cw-button`} >{"GO"}</button>
                                </div>
                                <div className="filter-button ml-3 d-inline-block" onClick={() => this.onClickClear()}>
                                    <button className={`cw-button clear-btn`}>{"CLEAR"}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    : ''}

                {/* {
                        this.state.totalVideoCount ? <div className='total-video-text text-right mr-3 mt-2'>Total Number of Videos : {this.state.totalVideoCount}</div> : <></>
                    } */}

                <div className="solved-examples-card mt-4">

                    {this.state.conceptsInfo?.length ? this.renderSolvedExamples() : <div className='d-flex justify-content-center pb-4'>No Video Content Found for this Chapter</div>}

                </div>


            </div>
        );
    }
}

export default ChapterAllVideos;